/**
 * fb#158 — สลิปแสดงแถวมาตรฐานครบทุกงวด (แบบสลิปกระดาษเดิมของ TN) แม้ยอดเป็น 0
 *
 * ลูกค้าขอ "ให้มีรายการเพิ่ม/หัก อื่น ๆ เตรียมไว้เลย" — สลิปเดิมโชว์เฉพาะบรรทัดที่มียอด
 * พนักงานเลยไม่เห็นว่างวดนี้ไม่มี OT/โบนัส/หักสาย หรือระบบลืม
 *
 * กติกา (แสดงผลล้วน ไม่แตะยอดเงิน — แถวที่เติมเป็น 0 เสมอ ยอดรวมจึงเท่าเดิม):
 * - แถวมาตรฐานที่ไม่มีบรรทัดจริงตรงหมวด → เติมแถว 0.00 ตามลำดับสลิปเดิม
 * - บรรทัดจริงที่ตรงหมวด → อยู่ในตำแหน่งของหมวดนั้น (ชื่อเดิม ไม่ยุบรวม ไม่เปลี่ยนชื่อ)
 * - บรรทัดจริงที่ไม่เข้าหมวดไหน (เช่น "ค่าเสื้อ") → แสดงชื่อจริงต่อท้าย = เป็น "อื่น ๆ" อยู่แล้ว
 *   แถว "อื่น ๆ" 0.00 จึงเติมเฉพาะเมื่อไม่มีบรรทัดแบบนี้ (ไม่ให้มี "ค่าเสื้อ 600" คู่กับ "อื่น ๆ 0.00")
 */
export interface SlipRowLine { label: string; amount: number }

interface StdRow { label: string; match: RegExp }

const EARN_ROWS: StdRow[] = [
  { label: 'เงินเดือน / ค่าจ้าง', match: /^(เงินเดือน|ค่าจ้าง)/ },
  { label: 'ค่าล่วงเวลา', match: /ล่วงเวลา|ทำงานวันหยุด|\bOT/ },
  { label: 'ค่านายหน้า / คอมมิชชั่น', match: /คอมมิช|นายหน้า/ },
  { label: 'ค่าเบี้ยเลี้ยง / ค่าครองชีพ', match: /เบี้ยเลี้ยง|ครองชีพ/ },
  { label: 'โบนัส', match: /โบนัส/ },
];
const EARN_OTHER = 'เงินได้อื่น ๆ';

const DED_ROWS: StdRow[] = [
  { label: 'ประกันสังคม', match: /ประกันสังคม/ },
  { label: 'ภาษีหัก ณ ที่จ่าย', match: /ภาษี/ },
  { label: 'เงินกู้ยืม กยศ. / กรอ.', match: /กยศ|กรอ/ },
  { label: 'เงินประกัน', match: /^เงินประกัน|หักประกันความเสียหาย/ },
  { label: 'ขาด / ลา / มาสาย', match: /หักลา|ขาดงาน|มาสาย|หักสาย|^ขาด/ },
];
const DED_OTHER = 'รายการหักอื่น ๆ';
// หมวดที่ไม่ได้อยู่บนสลิปเดิมแต่ก็ไม่ใช่ "อื่น ๆ" — ไม่ทำให้แถว "อื่น ๆ" หายไป
const DED_NOT_OTHER = /กองทุนสำรอง|กองทุนสงเคราะห์|เงินกู้บริษัท|ม\.76|หักวันหลังพ้นสภาพ/;

function fill(lines: SlipRowLine[], rows: StdRow[], otherLabel: string, notOther?: RegExp): SlipRowLine[] {
  const used = new Set<number>();
  const out: SlipRowLine[] = [];
  for (const row of rows) {
    let hit = false;
    lines.forEach((l, i) => {
      if (!used.has(i) && row.match.test(l.label)) { out.push(l); used.add(i); hit = true; }
    });
    if (!hit) out.push({ label: row.label, amount: 0 });
  }
  const rest = lines.filter((_, i) => !used.has(i));
  const hasOther = rest.some((l) => !(notOther?.test(l.label)));
  out.push(...rest);
  if (!hasOther) out.push({ label: otherLabel, amount: 0 });
  return out;
}

export function withStandardEarnings(lines: SlipRowLine[]): SlipRowLine[] {
  return fill(lines, EARN_ROWS, EARN_OTHER);
}
export function withStandardDeductions(lines: SlipRowLine[]): SlipRowLine[] {
  return fill(lines, DED_ROWS, DED_OTHER, DED_NOT_OTHER);
}
